rdefine("ag/editor",['backbone','text!ag/editor.html'],function(Backbone,template) {


    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'modal fade',
        bindings:{
            'input[name=action]':{
                value:'model.action'
            },
            'textarea':{
                value:'model.description'
            }
        },
        events: {
            "click .close-modal": "close",
            "click .delete-it":"deleteIt"
        },
        initialize:function(options) {
            this.$el.html(Template7.compile(template)({group_id:this.group_id,langs:AllLanguages,url:this.model.get("url")}));
            this.$el.modal();
            this.$el.on("hidden.bs.modal",this.removeIt.bind(this));


            this.slim = Slim.create(this.$el.find(".image-place-editor")[0], {
                 meta:{media_id:this.model.get('id')},
                service:'/frontend/api/ajax-gallery?media_id='+this.model.get("id"),
                "label":LANGUAGE["slim.label"],
                "buttonCancelTitle":LANGUAGE["basic.cancel"],
                "buttonEditTitle":LANGUAGE["slim.button-edit-title"],
                "buttonRemoveTitle":LANGUAGE["slim.button-remove-title"],
                "buttonDownloadTitle":LANGUAGE["slim.button-download-title"],
                "buttonUploadTitle":LANGUAGE["slim.button-upload-title"],
                "buttonConfirmTitle":LANGUAGE["basic.apply"],
                "buttonCancelLabel":LANGUAGE["basic.cancel"],
                "buttonEditLabel":LANGUAGE["slim.button-edit-label"],
                "buttonRemoveLabel":LANGUAGE["slim.button-remove-label"],
                "buttonDownloadLabel":LANGUAGE["slim.button-download-label"],
                "buttonUploadLabel":LANGUAGE["slim.button-upload-label"],
                "buttonConfirmLabel":LANGUAGE["basic.apply"],
                size:{width:2732,height:2732},
                download:true,
                push:true,
                /*   defaultInputName: this.fieldName+'[]',*/
                didInit: function() {
                    // load the file to our slim cropper

                },
                didUpload:function(err,obj,resp) {
                    this.model.set("url",resp.path);
                }.bind(this)
            });
            //load small gallery
        },
        reload:function(){
            this.col.loadSmall();
        },
        show:function(){
            this.$el.modal('show');
        },
        close:function(){
            $.post("/frontend/api/ajax-gallery/"+this.model.get("id"),{_method:"PUT",description:this.model.get("description"),action:this.model.get("action")},function(resp){
                SuccessMessage(resp.message);
            });
            this.$el.modal('hide');
        },
        removeIt:function(){
            //this.$el.modal('dispose');
            if(this.done) {
                this.done();
            }
            this.$el.remove();
        },
        deleteIt:function() {
            this.close();
            this.model.collection.remove(this.model);
            $.post("/frontend/api/ajax-gallery/"+this.model.get("id"),{"_method":"delete"},function(resp){
                SuccessMessage(resp.message);
            });
        }
    });
});